export const useProductFruitsEvent = (productFruitsEvent, ...rest) => {
  if (!window?.productFruits?.api?.analytics) return;

  window.productFruits.api.analytics.forwardEvent((event, data) => {
    productFruitsEvent(event, data, rest);
  });
};

